import { getTwigTemplate } from "../twig/twig";
import $ from "jquery";
import tinysort from "tinysort";
import NProgress from "nprogress";

let form,
  resultList,
  resultTemplate,
  filters,
  makeFilter,
  topicFilter,
  wordsFilter,
  sorters,
  contentWrapper;

const apiPath = "/wp-json/techcor/v1/sst/";

const defaultSelect2Config = {
  allowClear: true,
  placeholder: "",
};

const sstsort = () => {
  tinysort("[data-sst-result]", {
    data: "sort-" + sorters.filter(":checked").val(),
    order: sorters.filter(":checked").data("form-sorter-order"),
  });
};

function fetchAndRenderSearchResults(data) {
  NProgress.start();

  $.get(apiPath, data).done((data) => {
    contentWrapper.addClass("active");

    if (data.length) {
      resultList.html(
        data.map((item) => {
          return resultTemplate.render({ sst: item });
        })
      );

      appendNoResultTemplate();
      sstsort();
    } else {
      renderNoResults();
    }

    NProgress.done();
  });
}

function clearSelect2(select) {
  select.val(null);
  select
    .select2({ data: null, ...defaultSelect2Config })
    .on("select2:open", function () {
      $(".select2-search__field").attr("placeholder", "Type to search");
    });
}

function clearWords() {
  wordsFilter.val("");
}

const searchMakes = () => {
  clearSelect2(topicFilter);
  clearWords();
  fetchAndRenderSearchResults({ make: makeFilter.val() });
};

const searchTopics = () => {
  clearSelect2(makeFilter);
  clearWords();
  fetchAndRenderSearchResults({ topic: topicFilter.val() });
};

const expandYearRanges = (text) => {
  let expandedText = text;
  const regex = /(\d{4})\s*-\s*(\d{4})/gm;

  const range = (start, stop, step = 1) =>
    Array(Math.ceil((stop - start) / step))
      .fill(start)
      .map((x, y) => x + y * step);

  let m;
  while ((m = regex.exec(text)) !== null) {
    // This is necessary to avoid infinite loops with zero-width matches
    if (m.index === regex.lastIndex) {
      regex.lastIndex++;
    }
    const expandedYears = range(parseInt(m[1]), parseInt(m[2]) + 1);
    expandedText = expandedText.replace(m[0], expandedYears.join(" "));
  }

  return expandedText;
};

const removeParens = (text) => {
  const regex = /\([^)]+\)/gm;

  return text.replace(regex, "");
};

const searchWords = () => {
  let terms = wordsFilter.val();
  terms = terms.split(" ").map((term) => {
    return $.trim(term).toLowerCase();
  });

  const results = $("[data-sst-result]");

  results.each(function () {
    let text = $(this).find(".sst-result__name").text().toLowerCase();
    text = expandYearRanges(text);
    text = removeParens(text);

    const count = terms.reduce((count, term) => {
      return text.indexOf(term) !== -1 ? count + 1 : count;
    }, 0);

    $(this).toggleClass("hidden", terms.length !== count);
  });

  $("[data-sst-no-results]").toggleClass(
    "hidden",
    results.length !== results.filter(".hidden").length
  );
};

export default function initialize() {
  form = $("[data-form-filters]");
  filters = $("[data-form-filter]");
  resultList = $("[data-filtered-list]");
  sorters = $("[data-form-sorter]");
  contentWrapper = $("[data-content-wrapper]");
  resultTemplate = loadResultTemplate((template) => {
    resultTemplate = template;
  });

  form.on("submit", (e) => {
    e.preventDefault();
    searchWords();
  });

  makeFilter = filters.filter("[data-form-filter=make]");
  topicFilter = filters.filter("[data-form-filter=topic]");
  wordsFilter = filters.filter("[data-form-filter=words]");

  makeFilter.select2(defaultSelect2Config).on("select2:open", function () {
    $(".select2-search__field").attr("placeholder", "Type to search");
  });
  topicFilter.select2(defaultSelect2Config).on("select2:open", function () {
    $(".select2-search__field").attr("placeholder", "Type to search");
  });

  makeFilter.on("change", searchMakes);
  topicFilter.on("change", searchTopics);

  let wordFilterTimeout = null;
  wordsFilter.on("keyup", () => {
    clearTimeout(wordFilterTimeout);
    wordFilterTimeout = setTimeout(searchWords, 400);
  });
  sorters.on("click", sstsort);
}

function loadResultTemplate(callback) {
  return getTwigTemplate("components/sst-result.twig", callback);
}

function loadNoResultTemplate(callback) {
  return getTwigTemplate("components/sst-no-results.twig", callback);
}

function appendNoResultTemplate() {
  loadNoResultTemplate((template) => {
    resultList.html(resultList.html() + template.render());
  });
}

function renderNoResults() {
  loadNoResultTemplate((template) => {
    resultList.html(template.render());
  });
}



// WEBPACK FOOTER //
// ./scripts/lib/search/sst.js